const DATA_TYPE = {
  "TEXT": "text",
  "JSON": "json"
};

export default DATA_TYPE;
